module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('sub-ibox-title', {
    attrs: {
      "is-show-back": true
    }
  }, [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.params.id ? '编辑消息' : '发布消息'))])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "detail-cont"
  }, [_c('z-input', {
    staticClass: "m-t-15",
    attrs: {
      "maxlength": "40",
      "title": "标题",
      "isMust": "true"
    },
    model: {
      value: (_vm.params.title),
      callback: function($$v) {
        _vm.$set(_vm.params, "title", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "params.title"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fx fx-y-center m-t-20"
  }, [_vm._m(0), _vm._v(" "), _c('z-upload', {
    attrs: {
      "file-url": _vm.params.pic,
      "on-success": _vm.handleUploadSuccess
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pic-tips m-l-10"
  }, [_vm._v("建议尺寸：320*200")])], 1), _vm._v(" "), _vm._m(1)], 1), _vm._v(" "), _c('div', {
    staticClass: "m-t-20 fx btn-adaption"
  }, [_c('p', {
    staticClass: "w120 m-r-5 fx-shrink"
  }), _vm._v(" "), _c('a', {
    staticClass: "z-btn z-btn-primary b-r-3",
    on: {
      "click": _vm.handleAddBtn
    }
  }, [_vm._v("保存")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "title fx w120 m-r-5"
  }, [_c('i', {
    staticClass: "ask"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "fx-fill"
  }, [_vm._v("封面")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fx fx-y-center m-t-20"
  }, [_c('div', {
    staticClass: "title fx-shrink fx w120 m-r-5"
  }, [_c('p', {
    staticClass: "ask"
  }, [_vm._v("*")]), _c('span', {
    staticClass: "fx-fill"
  }, [_vm._v("消息内容")])]), _vm._v(" "), _c('div', {
    staticClass: "fx-fill"
  }, [_c('div', {
    staticClass: "fx-fill edit-width"
  }, [_c('div', {
    attrs: {
      "id": "message_center",
      "placeholder": "请在这里填写消息内容"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-21f52ef2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/mg/message/MessageEdit.vue
// module id = 826
// module chunks = 0